<template>
	<div class="page-main" style="position: relative; ">
		<div style="width: 1200px; display: flex; flex-direction: column;">
			<!-- 报名 -->
			<div style="display: inline-flex; flex-direction: column; width: 1200px;  z-index: 3;">
				<div style="display: flex; margin: 70px 0 40px 0;">
					<div style="margin-right: 10px;width: 5px;background: linear-gradient(to bottom,#ff9000,#c93a2e);">
					</div>
					<div style="display: flex;flex-direction: column; line-height: 1;font-size: 28px; color: #333;">
						机械工业出版社● 人工智能通识教材样书申请
					</div>
				</div>
			</div>
			
			<div v-if="page_index == 1"  style="display: flex;flex-direction: column; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding: 35px 35px 100px 35px; margin-bottom: 60px; ;line-height: 1;">
				<div style="display: flex; justify-content: space-between;padding-bottom: 30px; border-bottom: 1px solid #eee;">
					<div style="display: flex; flex-direction: column;font-size: 18px; color: #333;">
						<div style="font-weight: 600;">申请信息</div>
					</div>
				</div>

				<div style="display: flex;flex-direction: column; padding: 30px 0;" v-if="detailData">
					<div style="display: inline-block; width: 750px; padding-left:150px ; box-sizing: border-box; ">
						<el-form :model="dynamicValidateForm"  ref="dynamicValidateForm"  label-position="top" label-width="200px">
							<div v-for="(domain, index) in dynamicValidateForm.domains" :key="domain.key">
								<el-form-item :prop="'domains.' + index + '.book_id'" label="申请哪本样书"
									:rules="[ { required: true, message: '请选择样书', trigger: ['blur', 'change'] }]">
								    <el-radio-group v-model="domain.book_id" style="display: flex; height: 171px; margin-top: 10px;">
								      <el-radio :disabled="tem.book_nums==0?true:false" v-for="(tem,dex) in detailData.list" :label="tem.book_id" style="display: inline-flex; align-items: center;height: 171px; ">
										<div style="display: flex; flex-direction: column; align-items: center; width: 120px; ">
											<div style=" height: 144px;  position: relative;">
												<el-image style="height: 144px; " :src="tem.cover"></el-image>
												<div style="position: absolute; top: 0; right: 0; background-color: rgba(0, 0, 0, 0.3); font-size: 12px; padding: 4px 8px; color: #ccc;">库存：{{tem.book_nums}}</div>
											</div>
											
											<div style="height: 44px; margin-top: 5px;">
												<div style=" width: 120px;font-size: 12px; line-height:1.2; word-break: break-all; white-space: normal; text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden;">{{tem.title}}</div>
											</div>
											
										</div>
									  </el-radio>
								    </el-radio-group>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.name'" label="姓名"
									:rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.mobile'" label="手机"
									:rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.mobile" placeholder="请输入手机号码"></el-input>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.email'" label="邮箱"
									:rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.email" placeholder="请输入电子邮箱地址"></el-input>
								</el-form-item>
								
								<el-form-item label="邮寄地址" required>
									<el-col :span="8">
									  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省市区', trigger: ['blur', 'change']}]">
										<el-cascader placeholder="请选择省市区" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
									  </el-form-item>
									</el-col>
									<el-col :span="16">
									  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
										<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
									  </el-form-item>
									</el-col>
								</el-form-item> 
								
								<el-form-item 
									:prop="'domains.' + index + '.school'" label="学校"
									:rules="[ { required: true, message: '请输入学校', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.school" placeholder="请输入所在学校全称"></el-input>
								</el-form-item>
								<el-form-item 
									:prop="'domains.' + index + '.college'" label="院系"
									:rules="[ { required: true, message: '请输入院系', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.college" placeholder="请输入院系"></el-input>
								</el-form-item>
								
								<el-form-item
									:prop="'domains.' + index + '.course_name'" label="所授课程①"
									:rules="[ { required: true, message: '请输入所授课程', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.course_name" placeholder="请输入所授课程"></el-input>
								</el-form-item>
								<el-form-item 
									:prop="'domains.' + index + '.current_prep'" label="所用教材名称及出版社①"
									:rules="[ { required: true, message: '请输入所用教材名称及出版社', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.current_prep" placeholder="请输入所用教材名称及出版社"></el-input>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.course_name2'" label="所授课程②">
									<el-input v-model="domain.course_name2" placeholder="请输入所授课程"></el-input>
								</el-form-item>
								<el-form-item :prop="'domains.' + index + '.current_prep2'" label="所用教材名称及出版社②">
									<el-input v-model="domain.current_prep2" placeholder="请输入所用教材名称及出版社"></el-input>
								</el-form-item>
								
								<el-form-item
									:prop="'domains.' + index + '.use_type'" label="样书用途"
									:rules="[ { required: true, message: '请选择样书用途', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.use_type">
									  <el-radio label="意向用书"></el-radio>
									  <el-radio label="参考用书"></el-radio>
									</el-radio-group>
								</el-form-item>

							</div>
						</el-form>
					</div>
				</div>

				<div @click="infoConfirm" style="display: flex; justify-content: center; align-items: center; margin-top: 40px;">
					<div style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:150px ; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
						提交信息
					</div>
				</div>

			</div>
			
			<div v-if="page_index == 2"  style="display: flex;flex-direction: column; align-items: center; min-height: 70vh; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding: 120px 35px; margin-bottom: 60px; ;line-height: 1;">
				<img src="../../assets/images/icon_success.png" style="width: 120px; height: auto;" />
				<div style=" font-size: 24px; margin-top: 30px; color: #333;">
					申请信息已提交成功
				</div>
			</div>
			
			
			<div v-if="page_index == 3"  style="display: flex;flex-direction: column; align-items: center; min-height: 70vh; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding: 120px 35px; margin-bottom: 60px; ;line-height: 1;">
				<img src="../../assets/image/guanbi.png" style="width: 120px; height: auto;" />
				<div style=" font-size: 24px; margin-top: 30px; color: #333;">
					申请入口已关闭
				</div>
			</div>
			
			<div v-if="page_index == 4"  style="display: flex;flex-direction: column; align-items: center; min-height: 70vh; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding: 120px 35px; margin-bottom: 60px; ;line-height: 1;">
				<img src="../../assets/images/icon_success.png" style="width: 120px; height: auto;" />
				<div style=" font-size: 24px; margin-top: 30px; color: #333;">
					您已提交过申请信息
				</div>
			</div>
			
		</div>

	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";
	let pca = require("../../js/pca-code.json");

	export default {
		data() {
			return {
				dynamicValidateForm: {
					domains: [{
						apply_id: '',
						book_id: '',
						name: '',
						email: '',
						sex: '',
						pca: '',
						province: '',
						city: '',
						area: '',
						address: '',
						school: '',
						college: '',
						course_name: '',
						current_prep: '',
						course_name2: '',
						current_prep2: '',
						use_type: '',
					}]
				},
				options: pca,
				id: null,
				detailData: null,
				page_index: 1,
			};
		},
		created() {
			document.title = "机工教师特训营";
			var option = {
				id: this.$route.query.id || ""
			};
			if (option.id) {
				this.id = option.id;
				this.dynamicValidateForm.domains[0].apply_id = this.id;
				if(localStorage.getItem("apply_"+this.id)){
					this.page_index =4;
				}else{
					this.getDetail();
				}
			}
		},
		methods: {
			getDetail() {
				console.log();
				var that = this;
				var url = apiUrl.tt_apply_detail_get;
				var parms = { id: this.id };
				this.Ajax(url, parms, (data) => {
					that.detailData = data;
					if(that.detailData.state == 0){
						that.page_index =3;
					}
					console.log(that.detailData);
				});
			},
			infoConfirm(){
				var that = this;
				that.$refs['dynamicValidateForm'].validate((valid) => {
					if (valid) {
						that.dynamicValidateForm.domains.forEach((item,index)=>{
							if(item.pca && item.pca.length == 3){
								item.province = item.pca[0];
								item.city = item.pca[1];
								item.area = item.pca[2];
							}
						});
						that.confirmAjax();	
					}
				});
			},
			confirmAjax() {
				var that = this;
				var url = apiUrl.tt_apply_confirm;
				var parm = { user_list_json : JSON.stringify(this.dynamicValidateForm.domains)};
				this.Ajax(url, parm, (data) => {
					that.detailData  = data;
					that.page_index = 2;
					localStorage.setItem("apply_"+that.id,1);
				});
			},
			
		},
	};
</script>


<style lang="scss" scoped>
	
	.page-main {
		width: 100%;
		min-height: 100vh;
		background: #F1F1F1;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
	}
</style>